export default [
  {
    value: '3',
    label: 'Combined',
    name: 'All_Error_Flag',
  },
  {
    value: '2',
    label: 'Critical Flags',
    name: 'Critical_Error_Flag',
  },
  {
    value: '1',
    label: 'Non-Critical Flags',
    name: 'Non_Critical_Flag',
  },
  {
    value: '0',
    label: 'No Flags',
  },
];
